import { UntypedFormGroup, NgForm, NgModelGroup } from '@angular/forms';

export function touchForm(form: NgForm): void {
  for (const field in form.form.controls) {
    markAsTouched(field, form.form.controls);
  }
}

export function revalidateForm(form: NgForm): void {
  for (const field in form.form.controls) {
    revalidate(field, form.form.controls);
  }
}

export function touchGroup(group: NgModelGroup): void {
  for (const field in group.control.controls) {
    markAsTouched(field, group.control.controls);
  }
}

function markAsTouched(field: string, controls: any): void {
  const control = controls[field] as UntypedFormGroup;
  control.markAsTouched();

  if (control.controls) {
    for (const subField in control.controls) {
      markAsTouched(subField, control.controls);
    }
  }
}

function revalidate(field: string, controls: any): void {
  const control = controls[field] as UntypedFormGroup;
  control.updateValueAndValidity();

  if (control.controls) {
    for (const subField in control.controls) {
      revalidate(subField, control.controls);
    }
  }
}
